// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "ffd80d617191e940f1b65a80f8018d3a1900cd7e/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};